<div class="d-flex flex-column justify-content-center align-items-center bg-white py-5">
    <span class="ff-spectral fs-5 fw-bold text-primary mb-4">Share</span>
    <div *ngIf="currentUrl" class="d-flex justify-content-center text-primary">
        <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl" rel="noopener" target="_blank" class="icons__circle">
            <i class="fab fa-facebook-f"></i>
        </a>
        <a [href]="'https://twitter.com/intent/tweet?url=' + currentUrl" rel="noopener" target="_blank" class="icons__circle icons__share">
            <i class="fab fa-twitter"></i>
        </a>
        <a [href]="'http://pinterest.com/pin/create/link/?url=' + currentUrl" rel="noopener" target="_blank" class="icons__circle icons__share">
            <i class="fab fa-pinterest-p"></i>
        </a>
    </div>
</div>

